module.exports = __webpack_public_path__ + "img/serviceTypes.6e2b6b18.svg";